export default __webpack_public_path__ + "static/media/grafema_angura_01.b2f80637.mp4";